import styled from "styled-components";

const Media = {
  Laptop: "@media(max-width:1220px)",
  Nav: "@media(max-width:1000px)",
  Tablet: "@media(max-width:1000px)",
  PhoneLarge: "@media(max-width:600px)",
  PhoneSmall: "@media(max-width:400px)",
};

export const Container = styled.section`
  width: 100%;
  background-color: var(--preto-color);
  text-align: center;  
  padding-top: 3rem;
  color: var(--branco-color) !important;

  .footer{
    width: 100%;
    max-width: 90rem;
    height: auto;
    color: #000;
    padding-bottom: 10px;
    margin: auto;
    padding: 3rem 0rem;      
    
    ${Media.PhoneLarge} { 
      padding: 2rem 1rem;
    }

    .containerFooter{      
      width: 90%;
      margin: auto;
    }

    .container-top{
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: start;

      ${Media.Nav} { 
        align-items: end;
      }
      
      ${Media.PhoneLarge} { 
        flex-direction: column; 
        align-items: start;
        gap: 3rem;
      }
    }

     .container-information{
      display: flex;
      flex-direction: row;
      gap: 0.5rem;

      ${Media.Tablet}{
        flex-direction: column;
      }

      .selo{
        max-width: 89px;
        max-height: 89px;
      }

      .container-baba{
        display: flex;
        flex-direction: column;
        gap: 0rem;

        img{ 
          width: 100%;
          max-width: 280px; 
        }

        p{ 
          text-align: left; 
          color: var(--branco-color);
        }
      }
    }

    .social{ 
      display: flex;
      flex-direction: column;
      align-items: start;
      margin-top: 20px;

      ${Media.Tablet} { align-items: baseline; }
      
      p{ 
        text-align: left; 
        color: var(--branco-color) !important;
      
        ${Media.Tablet} { text-align: left; }
      }

      .icons{ 
        display: flex;
        flex-direction: row;
        align-items: end;
        gap: 1rem;     
        margin-top: 1rem;
        
        .face, .insta, .tik, .you{ 
          text-align: right;
          width: 25px;
          height: 25px;
          
          ${Media.Tablet} { text-align: left; }
        }

        .face, .insta, .tik, .you{ color: var(--verde-color); }
        .face:hover, .insta:hover, .tik:hover, .you:hover{ color: var(--branco-color); }
      }    
    }

    .websites{
      display: flex;
      flex-direction: column;
      align-items: end;
      gap: 0.5rem;

      ${Media.PhoneLarge} { align-items: baseline; }

      p{ 
        text-align: right; 
        color: var(--branco-color) !important;
      
        ${Media.PhoneLarge} { text-align: left; }
      }

      a{
        text-align: right;
        text-decoration: none;
        color: var(--verde-color);

        &:hover{
          color: var(--branco-color);
        }

        ${Media.PhoneLarge} { text-align: left; }
      }
    }

    .container-bottom{
      margin-top: 2rem;
      border-top: 1px solid var(--branco-color);
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding-top: 1rem;

      ${Media.PhoneSmall} { 
        gap: 2rem;
        flex-direction: column-reverse; 
      }      

      p{ 
        text-align: left; 
        color: var(--branco-color) !important;
        
        ${Media.PhoneSmall} { text-align: center; }
      }

      a{ color: var(--branco-color); }
      
      a:hover{
        color: var(--verde-color);
      }
    }
  }
`;
      